"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineDiscovery = void 0;
const configuration_1 = require("../../../../codegen/crm/timeline/configuration");
const index_1 = require("../../../../codegen/crm/timeline/index");
const rxjsStub_1 = require("../../../../codegen/crm/timeline/rxjsStub");
const ApiClientConfigurator_1 = require("../../../configuration/ApiClientConfigurator");
class TimelineDiscovery {
    constructor(config) {
        const configuration = (0, configuration_1.createConfiguration)(ApiClientConfigurator_1.ApiClientConfigurator.getParams(config, index_1.ServerConfiguration, rxjsStub_1.Observable, rxjsStub_1.Observable));
        this.eventsApi = new index_1.EventsApi(configuration);
        this.templatesApi = new index_1.TemplatesApi(configuration);
        this.tokensApi = new index_1.TokensApi(configuration);
    }
}
exports.TimelineDiscovery = TimelineDiscovery;
//# sourceMappingURL=TimelineDiscovery.js.map